import { AbstractControl, ValidationErrors } from '@angular/forms';

export function nullableRequiredValidator(control: AbstractControl): ValidationErrors | null {
  return (!control.value || !control.value.trim()) && control.value !== null ? { required: true } : null;
}
